import React, { useState } from 'react';
import { Horse, useHorse } from '../../contexts/HorseContext';
import { MarkModal } from './MarkModal';
interface HorseImageProps {
  horse: Horse;
}
export const HorseImage: React.FC<HorseImageProps> = ({
  horse
}) => {
  const {
    addMark,
    horses
  } = useHorse();
  const [modalOpen, setModalOpen] = useState(false);
  const [markPosition, setMarkPosition] = useState({
    x: 0,
    y: 0
  });
  // Get the current horse data directly from context to ensure it's always up-to-date
  const currentHorse = horses.find(h => h.id === horse.id) || horse;
  const handleImageClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * 100;
    const y = (e.clientY - rect.top) / rect.height * 100;
    setMarkPosition({
      x,
      y
    });
    setModalOpen(true);
  };
  const handleAddMark = (description: string) => {
    // Add the mark to the horse
    addMark(horse.id, {
      x: markPosition.x,
      y: markPosition.y,
      description
    });
    setModalOpen(false);
  };
  return <div className="bg-white rounded-lg shadow p-6 h-full flex flex-col" data-id="element-308">
      <h2 className="text-xl font-semibold mb-4" data-id="element-309">Pferd untersuchen</h2>
      <p className="text-sm text-gray-500 mb-4" data-id="element-310">
        Klicken Sie auf das Bild, um Merkmale oder Verletzungen zu markieren.
      </p>
      <div className="relative border border-gray-200 rounded-md cursor-crosshair bg-gray-50 flex-grow flex items-center justify-center" onClick={handleImageClick} data-id="element-311">
        {/* Horse skeleton image */}
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tARazP8X4w5FUECvV8zKt5/ChatGPT_Image_25._Sept._2025%2C_11_24_34.png" alt="Pferd Anatomie" className="max-w-full max-h-full object-contain" data-id="element-312" />
        {/* Display marks - use currentHorse to ensure immediate UI update */}
        {currentHorse.marks.map(mark => <div key={mark.id} data-mark-id={mark.id} className="absolute w-6 h-6 transform -translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full border-2 border-white cursor-pointer z-10" style={{
        left: `${mark.x}%`,
        top: `${mark.y}%`
      }} title={mark.description} data-id="element-313" />)}
      </div>
      <MarkModal isOpen={modalOpen} onClose={() => setModalOpen(false)} onSave={handleAddMark} data-id="element-314" />
    </div>;
};